import { useEffect, useState } from "react"
import Modal from 'react-bootstrap/Modal';
import AmountModeField from "../common/AmountModeField";
import { CheckNull, CurrencyConvertion, isNumberOnly, PriceCheck, QatarConvertion, calculateNetPrice } from "../../utils/Validate";
import { getSpecialColorDetails, saveSpecialColorDetail } from "../../utils/specialColorStorage";

export const QuotationSummary = ({ values, setValues, FormatValueDecimal, currencyList, currencyDetail, qarCurrencyDetail, editQuotation, setQuotUserEntry,
    quotUserEntry }) => {
    const [quotationSummary, setQuotationSummary] = useState({});
    const [specialColorModalShow, setSpecialColorModalShow] = useState(false);
    const [specialColorStorageRows, setSpecialColorStorageRows] = useState([]);


    const [taxMode, setTaxMode] = useState('$');
    const [customDutyMode, setCustomDutyMode] = useState('$');
    const [clearnceMode, setClearnceMode] = useState('$');

    const HandleCustomDutyModeChange = () => {
        setCustomDutyMode((prevMode) => (prevMode === '$' ? '%' : '$'));
        setQuotUserEntry({ ...quotUserEntry, customDutyPercentage: 0, customDuty: 0 })
    };

    const HandleClearnceModeChange = () => {
        setClearnceMode((prevMode) => (prevMode === '$' ? '%' : '$'));
        setQuotUserEntry({ ...quotUserEntry, clearanceChargesPercentage: 0, clearanceCharges: 0 })
    };

    const HandleTaxModeChange = () => {
        setTaxMode((prevMode) => (prevMode === '$' ? '%' : '$'));
        setQuotUserEntry({ ...quotUserEntry, tax: 0, taxPercentage: 0 })
    };

    useEffect(() => {
        let totListPrice = 0;
        let totNetPrice = 0;

        values?.products?.forEach((item) => {
            const listPrice = parseFloat(item?.listPrice);
            const safeListPrice = isNaN(listPrice) ? 0 : listPrice;

            totListPrice += safeListPrice;
            totNetPrice += calculateNetPrice(item);
        });

        setQuotationSummary({
            ...quotationSummary,
            totalListPrice: totListPrice,
            netPrice: totNetPrice,
        });
    }, [values?.products]);

    useEffect(() => {
        const newValues = {
            ...values,
            totalListPrice: quotationSummary?.totalListPrice,
            netPrice: quotationSummary?.netPrice,
        };
        setValues(newValues);
    }, [quotationSummary]);

    const calculateTotalDdp = (item, freightCustoms) => {
        const sellingPrice = calculateNetPrice(item);

        if (freightCustoms >= 1) return 0;

        const ddpMultiplier = 1 - freightCustoms;

        const finalDdp = sellingPrice / (ddpMultiplier || 1);

        if (!Number.isFinite(finalDdp)) return 0;

        return finalDdp.toFixed(2);
    };

    useEffect(() => {
        const totalExworksPrice = (values?.netPrice * 1) + (values.specialCharges * 1)
        const customDutyValue = customDutyMode === '$' ? (values?.customDuty * 1) : (((totalExworksPrice * 1) + (values?.freightCharges * 1)) * ((values?.customDutyPercentage * 1) / 100))
        const clearnceValue = clearnceMode === '$' ? (values?.clearanceCharges * 1) : (((totalExworksPrice * 1) + (values?.freightCharges * 1) + (customDutyValue * 1)) * ((values?.clearanceChargesPercentage * 1) / 100))
        const totalLandedCost = ((totalExworksPrice * 1) + (values?.freightCharges * 1) + (customDutyValue * 1) + (clearnceValue * 1))
        // const salesMarginValue = ((totalLandedCost * 1) / (1 - (values?.salesMarginPercentage / 100)))
        const salesMarginValue = totalLandedCost * 1
        const taxValue = taxMode === '$' ? (values?.tax * 1) : ((salesMarginValue * 1) * ((values?.taxPercentage * 1) / 100))
        // const taxValue = taxMode === '$' ? (values?.tax * 1) : ((values?.taxPercentage * 1) / 100)
        const grandTotal = taxValue + salesMarginValue
        // const frieghtcustoms = (totalLandedCost - (values?.netPrice * 1))
        const freightCustoms =
            (totalLandedCost - values?.netPrice) / totalLandedCost;

        const productsArr = values?.products?.map((item) => {
            const totalDdp = calculateTotalDdp(item, freightCustoms);
            return { ...item, totalDdp };
        });

        setValues((prev) => ({
            ...prev,
            products: productsArr,
            totalSellingPrice: parseFloat(salesMarginValue),
            totalExworksPrice: parseFloat(totalExworksPrice),
            grandTotal: parseFloat(grandTotal),
            totalLandedCost: parseFloat(totalLandedCost),
        }));
    }, [
        values?.specialCharges,
        values?.netPrice,
        values?.customDuty,
        values?.customDutyPercentage,
        values?.freightCharges,
        values?.clearanceCharges,
        values?.clearanceChargesPercentage,
        // values?.salesMarginPercentage,
        values?.tax,
        values?.taxPercentage,
        clearnceMode, customDutyMode, taxMode
    ]);

    useEffect(() => {
        if (values?.customDuty > 0) setCustomDutyMode('$')
        else setCustomDutyMode('%')
        if (values?.tax > 0) setTaxMode('$')
        else setTaxMode('%')
        if (values?.clearanceCharges > 0) setClearnceMode('$')
        else setClearnceMode('%')
    }, [values.id])

    const HandleInputChange = (e) => {
        const { name, value } = e.target;
        setQuotUserEntry({ ...quotUserEntry, [name]: value || 0 })
    }

    const getExistingSpecialCharge = () => {
        const userEntryCharge = Number(quotUserEntry?.specialCharges);
        if (Number.isFinite(userEntryCharge) && userEntryCharge > 0) return userEntryCharge;

        const valueCharge = Number(CurrencyConvertion(values?.specialCharges, values?.conversionRate, currencyDetail));
        return Number.isFinite(valueCharge) && valueCharge > 0 ? valueCharge : 0;
    };

    const hydrateSpecialColorCharges = (rows = []) => {
        const existingSpecialCharge = getExistingSpecialCharge();
        if (existingSpecialCharge <= 0) return rows;

        const currentQuoteRows = rows.filter(
            (item) => String(item?.quotationId) === String(values?.id)
        );
        const savedChargeTotal = currentQuoteRows.reduce(
            (total, item) => total + (Number(item?.charge) || 0),
            0
        );
        const remainingCharge = existingSpecialCharge - savedChargeTotal;

        if (remainingCharge <= 0) return rows;

        let appliedRemainingCharge = false;

        return rows.map((item) => {
            if (String(item?.quotationId) !== String(values?.id)) return item;
            if (appliedRemainingCharge) return item;
            if (item?.charge !== undefined && item?.charge !== null && item?.charge !== "") return item;

            appliedRemainingCharge = true;
            return {
                ...item,
                charge: remainingCharge,
            };
        });
    };

    useEffect(() => {
        if (!specialColorModalShow) return;
        let isMounted = true;

        getSpecialColorDetails(values?.id)
            .then((details) => {
                if (isMounted) {
                    const hydratedDetails = hydrateSpecialColorCharges(details || []);
                    const totalCharges = (hydratedDetails || []).reduce(
                        (total, item) => total + (Number(item?.charge) || 0),
                        0
                    );

                    setSpecialColorStorageRows(hydratedDetails);
                    if (totalCharges > 0) {
                        setQuotUserEntry((prev) => ({
                            ...prev,
                            specialCharges: totalCharges,
                        }));
                    }
                }
            })
            .catch(() => {
                if (isMounted) setSpecialColorStorageRows([]);
            });

        return () => {
            isMounted = false;
        };
    }, [specialColorModalShow, values?.id]);

    const hydratedSpecialColorStorageRows = hydrateSpecialColorCharges(specialColorStorageRows);

const specialColorRowsBase = hydratedSpecialColorStorageRows
    .filter((item) =>
        String(item?.quotationId) === String(values?.id) &&
        (values?.products || []).some(
            (product) => product?.markName === item?.markName
        )
    )
    .map((item) => {
        const surfaceValues = (item?.rows || []).reduce(
            (total, row) => {
                const powderArea = Number(row?.powderArea) || 0;
                const quantity = Number(row?.quantity) || 0;

                return {
                    powderArea: total.powderArea + powderArea,
                    totalSurfaceArea:
                        total.totalSurfaceArea + (powderArea * quantity),
                };
            },
            {
                powderArea: 0,
                totalSurfaceArea: 0
            }
        );

        return {
            markName: item?.markName,
            ralColor: item?.ralColorName || "-",
            powderArea: surfaceValues.powderArea,
            totalSurfaceArea: surfaceValues.totalSurfaceArea,
            charge: item?.charge ?? "",
        };
    })
    .filter((item) => Number(item?.powderArea) > 0);

    const specialColorRows = (() => {
        const hasRowCharges = specialColorRowsBase.some((row) => Number(row?.charge) > 0);
        const existingSpecialCharge = getExistingSpecialCharge();

        if (hasRowCharges || existingSpecialCharge <= 0 || specialColorRowsBase.length === 0) {
            return specialColorRowsBase;
        }

        return specialColorRowsBase.map((row, index) => ({
            ...row,
            charge: index === 0 ? existingSpecialCharge : row.charge,
        }));
    })();

    const updateSpecialColorChargeTotal = (rows) => {
        const totalCharges = (rows || []).reduce(
            (total, item) => total + (Number(item?.charge) || 0),
            0
        );

        setQuotUserEntry((prev) => ({
            ...prev,
            specialCharges: totalCharges > 0 ? totalCharges : 0,
        }));
    };

    const HandleSpecialColorChargeChange = (row, value) => {
        const visibleChargeByMark = specialColorRows.reduce((charges, item) => {
            charges[item?.markName] = item?.charge ?? "";
            return charges;
        }, {});

        const updatedRows = specialColorStorageRows.map((item) => {
            if (String(item?.quotationId) !== String(values?.id)) return item;

            const visibleCharge = visibleChargeByMark[item?.markName];

            if (item?.markName === row?.markName) {
                return { ...item, charge: value };
            }

            if ((item?.charge === undefined || item?.charge === null || item?.charge === "") && visibleCharge !== undefined) {
                return { ...item, charge: visibleCharge };
            }

            return item;
        });

        setSpecialColorStorageRows(updatedRows);
        updateSpecialColorChargeTotal(updatedRows);

        updatedRows
            .filter((item) => String(item?.quotationId) === String(values?.id))
            .forEach((item) => {
                saveSpecialColorDetail(item).catch(() => { });
            });
    };

    const formatSurfaceArea = (value) => {
        const numericValue = Number(value);
        if (!Number.isFinite(numericValue)) return "0 m2";
        return `${FormatValueDecimal(numericValue)} m2`;
        // return `${FormatValueDecimal(numericValue)}`;
    };

    useEffect(() => {
        setValues({
            ...values,
            specialCharges: QatarConvertion(quotUserEntry?.specialCharges, values?.conversionRate, currencyDetail) * 1 || 0,
            freightCharges: QatarConvertion(quotUserEntry?.freightCharges, values?.conversionRate, currencyDetail) * 1 || 0,
            customDuty: QatarConvertion(quotUserEntry?.customDuty, values?.conversionRate, currencyDetail) * 1 || 0,
            customDutyPercentage: (quotUserEntry?.customDutyPercentage) * 1 || 0,
            clearanceCharges: QatarConvertion(quotUserEntry?.clearanceCharges, values?.conversionRate, currencyDetail) * 1 || 0,
            clearanceChargesPercentage: (quotUserEntry?.clearanceChargesPercentage) * 1 || 0,
            // salesMarginPercentage: (quotUserEntry?.salesMarginPercentage)*1 || 0,
            tax: QatarConvertion(quotUserEntry?.tax, values?.conversionRate, currencyDetail) * 1 || 0,
            taxPercentage: (quotUserEntry?.taxPercentage) * 1 || 0
        })
    }, [quotUserEntry])

    return (
        <div className="card quotation-commercial-summary">
            <div className="card-header">
                <h5>{qarCurrencyDetail?.shortCode} : {FormatValueDecimal(CurrencyConvertion(values?.grandTotal, 1, qarCurrencyDetail))}</h5>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="mb-2">
                            <label>Net price</label>
                            <input
                                className="form-control"
                                type="text"
                                name="netPrice"
                                placeholder="Enter"
                                value={FormatValueDecimal(CurrencyConvertion(values?.netPrice, 1, qarCurrencyDetail))}
                                disabled="true"
                                style={{ textAlign: "right" }}
                            ></input>
                        </div>
                        <div className="mb-2">
                            <div className="d-flex align-items-center">
                                <label className="mr-1">Special color</label>
                                <button
                                    type="button"
                                    className="btn p-0 mb-1"
                                    aria-label="Open special color details"
                                    onClick={() => setSpecialColorModalShow(true)}
                                >
                                    <i className="fas fa-angle-right"></i>
                                </button>
                            </div>
                            <input
                                autoComplete="off"
                                type="number"
                                name="specialCharges"
                                step=".01"
                                min="0"
                                className="form-control"
                                placeholder="Enter"
                                onChange={HandleInputChange}
                                value={quotUserEntry.specialCharges > 0 ? quotUserEntry.specialCharges : ""}
                                onKeyPress={(e) => { return PriceCheck(e.target.value) }}
                                style={{ textAlign: "right" }}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                            />
                        </div>
                        <div className="mb-2">
                            <label>Total Ex-Works price</label>
                            <input
                                className="form-control"
                                type="text"
                                name="totalExworksPrice"
                                placeholder="Enter"
                                value={FormatValueDecimal(CurrencyConvertion(values?.totalExworksPrice, 1, qarCurrencyDetail))}
                                disabled="true"
                                style={{ textAlign: "right" }}
                            ></input>
                        </div>
                        <div className="mb-2">
                            <label>Frieght & delivery charges</label>
                            <input
                                autocomplete="off"
                                type="number"
                                name="freightCharges"
                                step=".01"
                                min="0"
                                className="form-control"
                                placeholder="Enter"
                                onChange={HandleInputChange}
                                value={quotUserEntry?.freightCharges > 0 ? quotUserEntry?.freightCharges : ""}
                                onkeypress={(e) => { return PriceCheck(e.target.value) }}
                                style={{ textAlign: "right" }}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                            />
                        </div>
                        <div className="mb-2">
                            <label>Custom Duty</label>
                            <AmountModeField
                                min="0"
                                mode={customDutyMode}
                                name={customDutyMode === '$' ? 'customDuty' : 'customDutyPercentage'}
                                onChange={HandleInputChange}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                onKeyPress={(e) => { return PriceCheck(e.target.value) }}
                                onModeToggle={HandleCustomDutyModeChange}
                                step=".01"
                                value={customDutyMode === '$' ? quotUserEntry?.customDuty > 0 ? quotUserEntry?.customDuty : "" :
                                    quotUserEntry?.customDutyPercentage > 0 ? quotUserEntry?.customDutyPercentage : ""}
                            />
                        </div>
                        <div className="mb-2">
                            <label>Clearance charges</label>
                            <AmountModeField
                                min="0"
                                mode={clearnceMode}
                                name={clearnceMode === '$' ? 'clearanceCharges' : 'clearanceChargesPercentage'}
                                onChange={HandleInputChange}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                onKeyPress={(e) => { return PriceCheck(e.target.value) }}
                                onModeToggle={HandleClearnceModeChange}
                                step=".01"
                                value={clearnceMode === '$' ? quotUserEntry?.clearanceCharges > 0 ? quotUserEntry?.clearanceCharges : "" :
                                    quotUserEntry?.clearanceChargesPercentage > 0 ? quotUserEntry?.clearanceChargesPercentage : ""}
                            />
                        </div>
                        <div className="mb-2">
                            <label>Total Landed Cost</label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Enter"
                                name="totalLandedCost"
                                disabled="true"
                                value={values?.totalLandedCost > 0 ? FormatValueDecimal(CurrencyConvertion(values?.totalLandedCost, 1, qarCurrencyDetail)) : 0}
                                style={{ textAlign: "right" }}
                            // onChange={HandleInputChange}
                            ></input>
                        </div>
                        {/* <div className="mb-2">
                            <label>Sales Margin (%)</label>
                            <input
                                autocomplete="off"
                                type="number"
                                name="salesMarginPercentage"
                                step=".01"
                                min="0"
                                className="form-control"
                                placeholder="Enter"
                                onChange={HandleInputChange}
                                value={quotUserEntry?.salesMarginPercentage > 0 ? quotUserEntry?.salesMarginPercentage : ""}
                                onkeypress={(e) => { return PriceCheck(e.target.value) }}
                                style={{ textAlign: "right" }}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                            />
                        </div> */}
                        <div className="mb-2">
                            <label>Total Selling Price</label>
                            <input
                                className="form-control"
                                type="text"
                                name="totalSellingPrice"
                                placeholder="Enter"
                                value={FormatValueDecimal(CurrencyConvertion(values?.totalSellingPrice, 1, qarCurrencyDetail))}
                                disabled="true"
                                style={{ textAlign: "right" }}
                            ></input>
                        </div>
                        <div className="mb-2">
                            <label>Tax</label>
                            <AmountModeField
                                min="0"
                                mode={taxMode}
                                name={taxMode === '$' ? 'tax' : 'taxPercentage'}
                                onChange={HandleInputChange}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                onKeyPress={(e) => { return PriceCheck(e.target.value) }}
                                onModeToggle={HandleTaxModeChange}
                                step=".01"
                                value={taxMode === '$' ? quotUserEntry?.tax > 0 ? quotUserEntry?.tax : "" :
                                    quotUserEntry?.taxPercentage > 0 ? quotUserEntry?.taxPercentage : ""}
                            />
                        </div>
                        <div className="mb-0 quotation-grand-total-field">
                            <label>Grand Total</label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Enter"
                                name="grandTotal"
                                disabled="true"
                                value={values?.grandTotal > 0 ? FormatValueDecimal(CurrencyConvertion(values?.grandTotal, 1, qarCurrencyDetail)) : 0}
                                style={{ textAlign: "right" }}
                            ></input>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                size="lg"
                show={specialColorModalShow}
                onHide={() => setSpecialColorModalShow(false)}
                className="special-color-modal-popup drawer right-align"
            >
                <Modal.Header>
                    <div className="d-flex justify-content-between align-items-center w-100">
                        <h5 className="mb-0">SPECIAL COLOR</h5>
                        <i className="fas fa-times" onClick={() => setSpecialColorModalShow(false)}></i>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="table-responsive">
                        <table className="table table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>RAL Color Code</th>
                                    {/* <th>Powder Area</th> */}
                                    <th>Total Surface Area (m²)</th>
                                    <th>Charges ({currencyDetail?.shortCode})</th>
                                </tr>
                            </thead>
                            <tbody>
                                {specialColorRows?.length > 0 ? (
                                    specialColorRows.map((row, index) => (
                                        <tr key={`${row.markName || "special-color"}-${index}`}>
                                            <td>{index + 1}</td>
                                            <td>{row.ralColor}</td>
                                            {/* <td>{formatSurfaceArea(row.powderArea)}</td> */}
                                            <td>{formatSurfaceArea(row.totalSurfaceArea)}</td>
                                            <td>
                                                <input
                                                    autoComplete="off"
                                                    type="number"
                                                    name={`specialColorCharge-${row.markName || index}`}
                                                    step=".01"
                                                    min="0"
                                                    className="form-control"
                                                    placeholder="Enter"
                                                    onChange={(e) => HandleSpecialColorChargeChange(row, e.target.value)}
                                                    value={row.charge !== undefined && row.charge !== null && row.charge !== "" ? row.charge : ""}
                                                    onKeyPress={(e) => { return PriceCheck(e.target.value) }}
                                                    style={{ textAlign: "right" }}
                                                    onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                                />
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center">No special color details available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn save-btn" type="button" onClick={() => setSpecialColorModalShow(false)}>
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

